export default "__VITE_ASSET__BwmHNf8M__"